import { render, staticRenderFns } from "./lt-comment.vue?vue&type=template&id=015857d6&scoped=true&"
import script from "./lt-comment.vue?vue&type=script&lang=js&"
export * from "./lt-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015857d6",
  null
  
)

export default component.exports